<template>
  <div>
    <div class="mb-3">
      <b>Your Sites</b>
      <span class="grey--text ml-2">({{ listMeta.total }})</span>
      <div
        class="text-right"
        style="margin-top: -40px;"
        v-if="listMeta.total > 0"
      >
        <b-button
          class="load-btn mr-3"
          :disabled="listMeta.current_page === 1"
          :style="listMeta.current_page > 1 ? '' : 'opacity: 0.5'"
          @click="loadPrevious"
        >
          <b-icon scale="0.8" icon="chevron-left" color="grey"></b-icon>
        </b-button>

        <b-button
          class="load-btn"
          :disabled="listMeta.current_page === listMeta.last_page"
          :style="
            listMeta.current_page < listMeta.last_page ? '' : 'opacity: 0.5'
          "
          @click="loadNext"
        >
          <b-icon scale="0.8" icon="chevron-right" color="grey"></b-icon>
        </b-button>
      </div>
    </div>

    <b-card class="empty-container" v-if="listMeta.total === 0">
      You have no sites yet.
      <b-link class="font-weight-bold" @click="$emit('openScanner')"
        >Scan QR Code</b-link
      >
    </b-card>

    <div v-else>
      <!-- Shimmer Effect -->
      <!-- <div class="shimmer-container" v-if="loading">
        <b-row>
          <b-col
            v-for="i in listLimit"
            :key="i"
            :style="isMobile ? '' : 'max-width: 25%;'"
          >
            <card-shimmer
              :imageHead="true"
              :withTitle="true"
              imageHeadHeight="130px"
            ></card-shimmer>
          </b-col>
        </b-row>
      </div>-->

      <!-- <transition :name="siteTransition"> -->
      <!-- <div v-show="!loading"> -->
      <b-row>
        <b-col
          v-for="site in list"
          :key="site.id"
          :style="isMobile ? '' : 'max-width: 25%;'"
        >
          <site-item :site="site" />
        </b-col>
      </b-row>
      <!-- </div> -->
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SiteItem from '@/components/cards/SiteItem'
// import CardShimmer from '@/components/shimmers/card'

export default {
  components: {
    SiteItem
    // CardShimmer
  },

  computed: {
    ...mapState({
      list: state => state.site.list,
      listMeta: state => state.site.listMeta
    }),

    listLimit() {
      return this.isMobile ? 1 : 4
    }
  },

  data() {
    return {
      loading: false,
      siteTransition: 'slide-fade-right',
      filters: {
        category_id: null,
        search: null,
        suburb: null,
        within_distance_to: null
      }
    }
  },

  methods: {
    ...mapActions({
      getSites: 'site/getSites'
    }),

    ...mapMutations({
      clearSites: 'site/clearSiteList'
    }),

    loadPrevious() {
      if (this.listMeta.current_page > 1) {
        this.fetchSites(this.listMeta.current_page - 1)
      }
      this.siteTransition = 'slide-fade-left'
    },

    loadNext() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchSites(this.listMeta.current_page + 1)
      }
      this.siteTransition = 'slide-fade-right'
    },

    async fetchSites(page = 1, selection = false) {
      if (this.loading && !selection) return
      const params = {
        page: page,
        limit: selection ? 10 : this.listLimit,
        selection
      }
      this.loading = true
      await this.getSites(params)
      this.loading = false
    }
  },

  created() {
    this.clearSites()
    this.fetchSites()
    this.fetchSites(1, true)
  }
}
</script>

<style scoped>
.row {
  margin: 0 -5px;
}
.col {
  padding: 0 5px;
}
.preview-container {
  width: unset;
  height: 358px;
  flex-wrap: unset;
}
.preview-item {
  background-color: transparent;
  width: 100%;
}
.btn {
  height: 46px;
  background: #ffffff33 0% 0% no-repeat padding-box;
  border: none;
}
.load-btn {
  background: #f2f3f6;
  padding: 0 10px;
  border-radius: 4px;
  height: 40px;
}
.empty-container {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 240px;
  text-align: center;
  padding-top: 85px;
  box-shadow: none;
}
</style>
